/**
 * Utility function to start a view transition in supported browsers.
 */
export function startViewTransition(cb: () => void) {
  if ('startViewTransition' in document) {
    document.startViewTransition(() => {
      cb();
    });
  } else {
    cb();
  }
}
